import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { AppSidebar, AppSidebarFooter, AppSidebarForm, AppSidebarHeader, AppSidebarNav } from '@coreui/react';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { faArrowRightArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Link as MuiLink } from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { getLocatedNavbar } from '../../_nav';
import useHasLeaderBoard from '../../hooks/useHasLeaderBoard';
import appService from '../../services/App';
import authService from '../../services/Auth';

function getAppLogo() {
  return appService.getCompanyAppLogo(authService.findUserCompany()?.code);
}

const SideBar = props => {
  const appLogo = useMemo(() => getAppLogo(), []);

  const { code: companyCode = '' } = authService?.findUserCompany() || {};
  const boardUrl =
    companyCode === 'CAPIFRANCE' ? process.env.REACT_APP_HORIZON_URL : process.env.REACT_APP_LEADERBOARD_URL;
  const boardLabel = companyCode === 'CAPIFRANCE' ? 'Horizon' : 'Espace Leader';
  const [navConfig, setNavConfig] = useState({});
  const { trackEvent } = useMatomo();
  const fetchNavConfig = useCallback(async () => {
    const data = await (
      await fetch('https://s3.eu-central-1.amazonaws.com/assets.digitregroup.io/config-nav.json', { cache: 'no-cache' })
    ).json();
    setNavConfig({ ...data, trackEvent });
  }, [trackEvent]);

  useEffect(() => {
    fetchNavConfig();
  }, [fetchNavConfig]);

  const LeaderBoardLink = () => (
    <MuiLink
      component='a'
      variant='body'
      href={boardUrl}
      target='_blank'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '16px',
        marginBottom: '12px',
        '&:hover': { textDecoration: 'none' },
      }}
    >
      <FontAwesomeIcon icon={faArrowRightArrowLeft} color='#5EB4F9' />
      <Box ml={1} sx={{ color: '#5EB4F9' }}>
        {boardLabel}
      </Box>
    </MuiLink>
  );

  const hasLeaderBoard = useHasLeaderBoard();

  return (
    <AppSidebar fixed display='lg'>
      <AppSidebarHeader>
        <Link to={'/'}>
          {authService.findUserCompany()?.code === 'OPTIMHOME' ? (
            <img src={appLogo} width={'100%'} height={'auto'} alt={'logo'} />
          ) : (
            <img src={appLogo} height={40} alt={'logo'} />
          )}
        </Link>
        {hasLeaderBoard && <LeaderBoardLink />}
      </AppSidebarHeader>
      <AppSidebarForm />
      <AppSidebarNav navConfig={getLocatedNavbar(props.location.pathname, navConfig)} {...props} />
      <AppSidebarFooter />
    </AppSidebar>
  );
};

SideBar.propTypes = {
  location: PropTypes.object,
};

SideBar.defaultProps = {
  location: { pathname: [] },
};
export default SideBar;
